import IconeProcurador from '@mui/icons-material/AssignmentInd';
import CancelIcon from '@mui/icons-material/Cancel';
import Clear from '@mui/icons-material/Clear';
import Delete from '@mui/icons-material/Delete';
import PersonAdd from '@mui/icons-material/PersonAdd';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import SaveIcon from '@mui/icons-material/Save';
import ThumbUpAlt from '@mui/icons-material/ThumbUpAlt';
import {
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Radio,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';
import { action, computed, makeObservable, observable, reaction, runInAction, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';

import { ROTA } from '@/dominio/Rota';
import IconeMagistrado from '@/img/IconeMagistrado';

import Configuracao from '../../util/Configuracao';
import ErrorUtil from '../../util/ErrorUtil';
import {
    filtrarImpedimentosMagistrado,
    filtrarOpcoesDisponiveis,
    getComposicaoPadraoSessao,
    getIconesImpedimentoMagistrado,
    getOpcoesMagistrados
} from '../../util/ImpedimentosMagistrados';
import AutoComplete from '../AutoComplete';
import IconeOrigem from '../IconeOrigem';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import BotaoAlternarSigla from './BotaoAlternarSigla';
import {
    renderAvisoMagistradoJaSubstituto,
    renderBotaoRedefinirComposicao,
    renderCelulaSubstituto,
    renderChipOrigemSigla,
    renderIconeSubstituicao
} from './ComposicaoRenders';
import ComposicaoUtil from './ComposicaoUtil';
import FiltroRapido from './FiltroRapido';
import ModalConfirmacao from './ModalConfirmacao';
import ObservacaoCertidaoUtil from './ObservacaoCertidaoUtil';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';
import ProcuradorSessao from './ProcuradorSessao';

class ComposicaoEmLote extends ReactComponent {
    dialogOpen = false;
    dialogComposicaoOpen = false;
    dialogProcuradorOpen = false;
    novaComposicao = [];
    magistradoParaAdicionar;
    procuradoresSelecionados = {};
    atualizarCertidaoComposicao = false;
    atualizarCertidaoProcurador = false;
    exibirAtualizarCertidao = false;
    tooltipAtualizarCertidao = '';
    modalConfirmacaoMagistradoOpen = false;
    modalConfirmacaoAlertaOpen = false;
    registroSelecionadoModal = null;
    modalConfirmacaoFecharComposicaoOpen = false;
    dialogRemocaoAberto = false;
    desmarcandoProcessos = false;
    magistradoParaRemover = null;
    registroVirtualComposicao = {
        sessaoId: null,
        composicao: [],
        impedimentos: [],
        certidaoGerada: false,
        certidaoJulgamentoAssinada: false,
        necessitaImportacaoSalaSessao: false,
        processo: { origem: Configuracao.ORIGEM_PJE }
    };

    handleClickIcone = () => {
        this.dialogOpen = true;
        this.atualizarCertidaoComposicao = false;
        this.atualizarCertidaoProcurador = false;
    };

    handleCloseDialog = () => {
        this.dialogOpen = false;
    };

    handleClickIconeProcurador = async () => {
        this.prepararAtualizarCertidao();

        if (this.processosSelecionados.length > 0) {
            await this.recuperarProcuradoresSessoes();
            runInAction(() => (this.dialogProcuradorOpen = true));
        } else {
            this.mensagemStore.abrirMensagemAlerta('Selecione um ou mais processos para alterar o procurador');
        }
    };

    handleClickIconeComposicao = () => {
        this.prepararAtualizarCertidao();

        if (this.processosSelecionados.length === 0) {
            this.mensagemStore.abrirMensagemAlerta('Selecione um ou mais processos para alterar a composição');
            return;
        }

        const primeiraComposicao = this.processosSelecionados[0].composicao;

        const todosIguais = this.processosSelecionados.every((processo) =>
            ComposicaoUtil.composicoesIguais(processo.composicao, primeiraComposicao)
        );

        const composicaoInicial = todosIguais
            ? primeiraComposicao.map((c) => ({ ...c, magistrado: { ...c.magistrado } }))
            : this.composicaoPadraoSessao;

        if (todosIguais && !this.mesmoPresidenteEmTodos()) {
            for (const comp of composicaoInicial) {
                comp.magistrado.presidenteSessao = false;
            }
        }

        this.novaComposicao = this.normalizarPresidentes(composicaoInicial);
        this.atualizarRegistroVirtual();
        this.dialogComposicaoOpen = true;
    };

    handleCloseDialogProcurador = () => {
        this.dialogProcuradorOpen = false;
    };

    fecharDialogComposicao = () => {
        if (this.composicaoFoiAlterada) {
            this.modalConfirmacaoFecharComposicaoOpen = true;
            return;
        }
        this.handleCloseDialogComposicao();
    };

    callbackConfirmarFecharComposicao = () => {
        this.modalConfirmacaoFecharComposicaoOpen = false;
        this.handleCloseDialogComposicao();
    };

    callbackCancelarFecharComposicao = () => {
        this.modalConfirmacaoFecharComposicaoOpen = false;
    };

    handleCloseDialogComposicao = () => {
        this.dialogComposicaoOpen = false;
    };

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    handleClickAlterarProcuradores = async () => {
        await this.store.processarLote({
            titulo: 'Alterando procuradores',
            qtdTotalProcessos: this.processosSelecionados.length,
            lotesProcessos: this.processosSelecionados,
            funcaoOperacao: (registro) => this.gravarProcurador(registro)
        });
        this.handleCloseDialogProcurador();
    };

    callbackCancelar = () => {
        this.modalConfirmacaoMagistradoOpen = false;
        this.modalConfirmacaoAlertaOpen = false;
    };

    handleClickAlterarComposicoes = () => {
        this.modalConfirmacaoMagistradoOpen = true;
    };

    callbackConfirmarMagistrado = async () => {
        this.modalConfirmacaoMagistradoOpen = false;
        const magistrados = this.novaComposicao.map((comp) => {
            return {
                id: comp.magistrado.id,
                presidenteSessao: comp.magistrado.presidenteSessao,
                sigla: comp.magistrado.sigla,
                cpf: comp.magistrado.cpf,
                ausente: comp.magistrado.ausente,
                genero: comp.magistrado.genero,
                nome: comp.magistrado.nome,
                codigoCargo: comp.magistrado.codigoCargo,
                converterSigla: comp.magistrado.converterSigla,
                siglaAdministrativa: comp.magistrado.siglaAdministrativa
            };
        });
        const magistradosValidos = await this.validarMagistrados(magistrados);

        if (magistradosValidos) {
            await this.alterarComposicoesEmLote(magistrados);
        }
    };

    toggleMagistradoPresidente = (magistrado) => {
        ComposicaoUtil.definirPresidente(this.novaComposicao, magistrado);
    };

    toggleMagistradoAusente = (magistrado) => {
        magistrado.ausente = !magistrado.ausente;
    };

    abrirDialogoRemocao = () => {
        this.dialogRemocaoAberto = true;
    };

    fecharDialogoRemocao = () => {
        this.dialogRemocaoAberto = false;
    };

    handleClickRemoverMagistrado = (magistrado) => {
        this.magistradoParaRemover = magistrado;

        if (this.dadosDialogRemocao) {
            this.abrirDialogoRemocao();
        } else {
            this.removerMagistrado(magistrado);
        }
    };

    removerMagistrado = (magistrado) => {
        if (!magistrado) {
            this.fecharDialogoRemocao();
            return;
        }

        ComposicaoUtil.removerMagistrado(this.novaComposicao, magistrado);
        this.fecharDialogoRemocao();
    };

    desmarcarProcessosComRelator = async (magistrado) => {
        runInAction(() => {
            this.desmarcandoProcessos = true;
            this.dialogRemocaoAberto = false;
        });

        await new Promise((resolve) => setTimeout(resolve, 50));

        runInAction(() => {
            for (const registro of this.processosSelecionados) {
                if (this.isRelatorOuRedatorDoProcesso(magistrado, registro)) {
                    this.store.uncheckOperacoesEmLote(registro);
                }
            }

            if (this.processosSelecionados.length === 0) {
                this.dialogComposicaoOpen = false;
                this.modalConfirmacaoMagistradoOpen = false;
            } else {
                this.prepararAtualizarCertidao();
                this.atualizarRegistroVirtual();
            }

            this.desmarcandoProcessos = false;
        });
    };

    handleClickRedefinirParaComposicaoPadrao = () => {
        if (ComposicaoUtil.mesmosMagistrados(this.novaComposicao, this.composicaoPadraoSessao)) {
            return;
        }
        this.novaComposicao = toJS(this.composicaoPadraoSessao);
        this.atualizarRegistroVirtual();
    };

    callbackAutoCompleteMagistradoSubstituto = async (magistrado, option) => {
        const magistradoSelecionado = option ? option.valor : null;

        if (!magistradoSelecionado) {
            return;
        }

        try {
            const situacao = await this.validarLocalizacaoMagistrado(magistradoSelecionado);

            if (situacao.tipo !== 'SUCESSO') {
                this.mensagemStore.abrirMensagemAlerta(situacao.mensagem);
                return;
            }

            runInAction(() => {
                this.novaComposicao.push(
                    ComposicaoUtil.criarEntradaComposicao(magistradoSelecionado, {
                        magistradoSubstituido: ComposicaoUtil.resumoMagistrado(magistrado)
                    })
                );

                ComposicaoUtil.definirSubstituto(magistrado, magistradoSelecionado);
            });
        } catch (error) {
            console.error(error);
            this.mensagemStore.abrirMensagemErro('Não foi possível verificar se magistrado pode ser adicionado.');
        }
    };

    removerSubstituto = (magistrado, substituto) => {
        const entrada = this.novaComposicao.find(
            (comp) =>
                (substituto.cpf && comp.magistrado.cpf === substituto.cpf) || comp.magistrado.sigla === substituto.sigla
        );

        this.handleClickRemoverMagistrado(entrada ? entrada.magistrado : substituto);
    };

    callbackAutoCompleteAddMagistrado = (option) => {
        this.magistradoParaAdicionar = option ? option.valor : null;
    };

    adicionarMagistrado = async () => {
        try {
            const situacao = await this.validarLocalizacaoMagistrado();

            if (situacao.tipo === 'SUCESSO') {
                runInAction(() => {
                    this.novaComposicao.push(ComposicaoUtil.criarEntradaComposicao(this.magistradoParaAdicionar));

                    this.magistradoParaAdicionar = undefined;

                    ComposicaoUtil.rolarParaFim('#tBodyComposicaoProcessoLote');
                });
            } else {
                this.mensagemStore.abrirMensagemAlerta(situacao.mensagem);
            }
        } catch (error) {
            console.error(error);
            this.mensagemStore.abrirMensagemErro('Não foi possível verificar se magistrado pode ser adicionado.');
        }
    };

    callbackAutoCompleteProcurador = (valor, idSessao) => {
        this.procuradoresSelecionados[idSessao] = valor;
    };

    handleChangeAtualizarCertidaoComposicao = () => {
        this.atualizarCertidaoComposicao = !this.atualizarCertidaoComposicao;
    };

    handleChangeAtualizarCertidaoProcurador = () => {
        this.atualizarCertidaoProcurador = !this.atualizarCertidaoProcurador;
    };

    handleClickWarningComposicao = (registro) => {
        this.registroSelecionadoModal = registro;
        this.modalConfirmacaoAlertaOpen = true;
    };

    callbackConfirmarAlertaComposicao = async () => {
        this.modalConfirmacaoAlertaOpen = false;
        await this.certidaoService.removerAssinaturaCertidao(
            this.registroSelecionadoModal.sessaoId,
            this.registroSelecionadoModal.processo.numeroCompleto
        );
        runInAction(() => (this.registroSelecionadoModal.certidaoJulgamentoAssinada = false));
    };

    renderModalAlertaComposicao = () => {
        return this.registroSelecionadoModal ? (
            <ModalConfirmacao
                callbackCancelar={this.callbackCancelar}
                callbackConfirmar={this.callbackConfirmarAlertaComposicao}
                open={this.modalConfirmacaoAlertaOpen}
                titulo={'Remover assinatura?'}
            >
                <Typography display="inline">
                    Deseja remover a assinatura da certidão de julgamento do processo
                </Typography>
                <Typography
                    noWrap
                    display="inline"
                    fontWeight="bold"
                >
                    {' '}
                    {this.registroSelecionadoModal?.processo.numeroCompleto}
                </Typography>
                <Typography display="inline">?</Typography>
            </ModalConfirmacao>
        ) : null;
    };

    getAlertasProcesso = (registro) => {
        const alertas = [];

        if (registro.certidaoJulgamentoAssinada) {
            alertas.push({
                mensagem:
                    'Não é possível alterar a composição de processo com certidão assinada. ' +
                    'Para remover a assinatura, clique no ícone.',
                impeditivo: true,
                handleClick: this.handleClickWarningComposicao
            });
        }
        return alertas;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            getResumoRelatorRedator: false,
            getProcessosRedator: false,
            isRelatorOuRedatorDoProcesso: false,
            getProcessosRelatorOuRedator: false,
            getTituloRedator: false,
            handleClickWarningComposicao: action,
            callbackConfirmarAlertaComposicao: action,
            renderModalAlertaComposicao: false,
            getAlertasProcesso: false,
            observacaoDeps: false,
            deveDesabilitarBotaoSalvar: false,
            modalConfirmacaoFecharComposicaoOpen: observable,
            modalConfirmacaoAlertaOpen: observable,
            registroSelecionadoModal: observable,
            fecharDialogComposicao: action,
            callbackConfirmarFecharComposicao: action,
            callbackCancelarFecharComposicao: action,
            chave: false,
            mesmoPresidenteEmTodos: false,
            registroVirtualComposicao: observable,
            renderSubstituicao: false,
            renderComboSubstituicao: false,
            renderAdicionarRemoverMagistradoSubstituto: false,
            renderListaProcessos: false,
            renderTextoDialogRemocao: false,
            renderBotoesDialogRemocao: false,
            renderRedefinirParaComposicaoPadrao: false,
            normalizarPresidentes: false,
            isRelatorDoProcesso: false,
            recuperarProcuradoresSessoes: false,
            prepararAtualizarCertidao: false,
            composicaoPadraoSessao: false,
            processosSelecionadosPauta: false,
            processosSelecionaveisPauta: false,
            processosSelecionaveis: false,
            processosSelecionaveisPorPagina: false,
            gravarProcurador: false,
            atualizarCertidao: false,
            renderModalAlterarComposicaoMagistrados: false,
            alterarComposicoesEmLote: false,
            validarMagistrados: false,
            gravarComposicao: false,
            atualizarResumoCertidao: false,
            validarLocalizacaoMagistrados: false,
            validarLocalizacaoMagistrado: false,
            atualizarRegistroVirtual: action,
            getProcessosRelator: false,
            getRolesMagistrado: false,
            render: false,
            renderOpcaoAtualizarCertidao: false,
            dialogOpen: observable,
            dialogComposicaoOpen: observable,
            dialogProcuradorOpen: observable,
            novaComposicao: observable,
            magistradoParaAdicionar: observable,
            procuradoresSelecionados: observable,
            atualizarCertidaoComposicao: observable,
            atualizarCertidaoProcurador: observable,
            exibirAtualizarCertidao: observable,
            tooltipAtualizarCertidao: observable,
            modalConfirmacaoMagistradoOpen: observable,
            dialogRemocaoAberto: observable,
            magistradoParaRemover: observable,
            abrirDialogoRemocao: action,
            fecharDialogoRemocao: action,
            handleClickRemoverMagistrado: action,
            desmarcarProcessosComRelator: action,
            desmarcandoProcessos: observable,
            renderCarregando: false,
            handleClickRedefinirParaComposicaoPadrao: action,
            dadosDialogRemocao: computed,
            renderDialogRemocao: computed,
            opcoesMagistradosSubstituto: computed,
            callbackAutoCompleteMagistradoSubstituto: action,
            removerSubstituto: action,
            handleClickIcone: action,
            handleCloseDialog: action,
            handleClickIconeProcurador: action,
            handleClickIconeComposicao: action,
            handleCloseDialogProcurador: action,
            handleCloseDialogComposicao: action,
            processos: computed,
            processosPauta: computed,
            processosPorPagina: computed,
            limparProcessoPesquisa: action,
            processosSelecionados: computed,
            handleClickAlterarProcuradores: action,
            callbackCancelar: action,
            handleClickAlterarComposicoes: action,
            callbackConfirmarMagistrado: action,
            processosSelecionadosPorSessao: computed,
            sessoesProcessos: computed,
            atualizarRelatorProcesso: action,
            toggleMagistradoPresidente: action,
            toggleMagistradoAusente: action,
            opcoesMagistradosAdicionar: computed,
            opcoesMagistrados: computed,
            impedimentos: computed,
            removerMagistrado: action,
            callbackAutoCompleteAddMagistrado: action,
            adicionarMagistrado: action,
            callbackAutoCompleteProcurador: action,
            handleChangeAtualizarCertidaoComposicao: action,
            handleChangeAtualizarCertidaoProcurador: action,
            mensagemLoteSemProcessos: computed,
            renderConteudoComposicaoLote: computed,
            renderTituloComposicaoLote: computed,
            renderConteudoDialogProcurador: computed,
            renderConteudoDialogComposicao: computed,
            existePresidenteNaComposicao: computed,
            existeMaisDeUmPresidenteNaComposicao: computed,
            composicaoFoiAlterada: computed
        });

        this.createReaction(
            reaction(
                () => this.dialogOpen,
                () => this.limparProcessoPesquisa()
            )
        );
    }

    get composicaoFoiAlterada() {
        const chaveNova = ComposicaoUtil.chaveComposicao(this.novaComposicao);

        return this.processosSelecionados.some(
            (registro) => ComposicaoUtil.chaveComposicao(registro.composicao) !== chaveNova
        );
    }

    get opcoesMagistradosSubstituto() {
        return filtrarOpcoesDisponiveis(
            this.opcoesMagistrados,
            this.novaComposicao,
            ComposicaoUtil.localizacaoUsuario(this.usuarioStore)
        );
    }

    renderSubstituicao(magistrado) {
        return ComposicaoUtil.isMagistradoSubstitutoDefinido(magistrado) || magistrado.magistradoSubstituido
            ? renderIconeSubstituicao(magistrado)
            : '';
    }

    renderComboSubstituicao(magistrado, index) {
        if (!magistrado.ausente) {
            return null;
        }

        return ComposicaoUtil.shouldEsconderComboSubstituto(magistrado) ? (
            renderAvisoMagistradoJaSubstituto(magistrado)
        ) : (
            <AutoComplete
                apresentarTextoSecundario
                outlined
                disabled={ComposicaoUtil.isMagistradoSubstituidoDefinido(magistrado)}
                id={'composicaoLote' + index}
                label="Selecione..."
                onChange={(option) => this.callbackAutoCompleteMagistradoSubstituto(magistrado, option)}
                options={this.opcoesMagistradosSubstituto}
            />
        );
    }

    renderAdicionarRemoverMagistradoSubstituto(magistrado, index) {
        return renderCelulaSubstituto(magistrado, this.removerSubstituto, () =>
            this.renderComboSubstituicao(magistrado, index)
        );
    }

    get dadosDialogRemocao() {
        const magistrado = this.magistradoParaRemover;

        if (!magistrado) return null;

        const flexaoGenero = magistrado.genero === 'M' ? 'o' : 'a';
        const flexaoCargo = magistrado.genero === 'M' ? '' : 'a';
        const processosRelator = this.getProcessosRelator(magistrado);
        const processosRedator = this.getProcessosRedator(magistrado);
        const processosRelatorOuRedator = this.getProcessosRelatorOuRedator(magistrado);

        if (processosRelatorOuRedator.length > 0) {
            const cargos = [];

            if (processosRelator.length > 0) cargos.push(`relator${flexaoCargo}`);
            if (processosRedator.length > 0) cargos.push(`redator${flexaoCargo}`);

            const plural = processosRelatorOuRedator.length > 1 ? 'nos processos' : 'no processo';

            return {
                mensagemTexto: `${magistrado.nome} é ${cargos.join(' e ')} ${plural}`,
                listaProcessos: processosRelatorOuRedator,
                mensagemSufixo: `E não pode ser removid${flexaoGenero}`,
                actions: ['DESMARCAR_PROCESSOS', 'OK']
            };
        }

        const impedimentosMagistrado = filtrarImpedimentosMagistrado(magistrado, this.impedimentos);

        if (magistrado.situacaoImpedimento || impedimentosMagistrado.length > 0) {
            const numerosProcessosImpedidos = new Set(impedimentosMagistrado.map((imp) => imp.numeroProcesso));
            const processosImpedidos = this.processosSelecionados.filter((r) =>
                numerosProcessosImpedidos.has(r.processo?.numeroCompleto)
            );

            return {
                mensagemTexto: `${magistrado.nome} é impedid${flexaoGenero} nos processos:`,
                listaProcessos: processosImpedidos,
                mensagemSufixo: 'Confirma a remoção?',
                actions: ['CANCELAR', 'REMOVER']
            };
        }

        if (magistrado.presidenteSessao && !this.existeMaisDeUmPresidenteNaComposicao) {
            return {
                mensagemTexto: `${magistrado.nome} é presidente da sessão. Confirma a remoção?`,
                listaProcessos: null,
                actions: ['CANCELAR', 'REMOVER']
            };
        }

        return null;
    }

    renderListaProcessos(processos, possuiMuitosProcessos) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px',
                    marginTop: '8px',
                    marginBottom: '8px',
                    ...(possuiMuitosProcessos && { maxHeight: '150px', overflowY: 'auto', paddingRight: '8px' })
                }}
            >
                {processos.map((registro) => (
                    <div
                        key={registro.processo?.id || registro.processo?.numeroCompleto}
                        style={{ display: 'flex', alignItems: 'center', gap: '8px', minHeight: '24px' }}
                    >
                        <Typography variant="body2"> {registro.processo.numeroCompleto} </Typography>
                        <IconeOrigem
                            origem={registro.processo.origem}
                            processo={registro.processo}
                        />
                    </div>
                ))}
            </div>
        );
    }

    renderTextoDialogRemocao() {
        const dados = this.dadosDialogRemocao;

        if (!dados) return null;

        return (
            <>
                <Typography>{dados.mensagemTexto}</Typography>
                {dados.listaProcessos ? this.renderListaProcessos(dados.listaProcessos, true) : null}
                {dados.mensagemSufixo ? <Typography sx={{ mt: 1 }}>{dados.mensagemSufixo}</Typography> : null}
            </>
        );
    }

    renderBotoesDialogRemocao(dados) {
        if (!dados || !dados.actions) return null;

        return (
            <DialogActions>
                {dados.actions.includes('DESMARCAR_PROCESSOS') && (
                    <Button
                        color="inherit"
                        endIcon={<RemoveDoneIcon />}
                        onClick={() => this.desmarcarProcessosComRelator(this.magistradoParaRemover)}
                        variant="outlined"
                    >
                        Desmarcar processos
                    </Button>
                )}
                {dados.actions.includes('CANCELAR') && (
                    <Button
                        color="secondary"
                        endIcon={<CancelIcon />}
                        onClick={this.fecharDialogoRemocao}
                        variant="outlined"
                    >
                        Cancelar
                    </Button>
                )}
                {dados.actions.includes('REMOVER') && (
                    <Button
                        color="primary"
                        endIcon={<Delete />}
                        onClick={() => this.removerMagistrado(this.magistradoParaRemover)}
                        variant="outlined"
                    >
                        Remover
                    </Button>
                )}
                {dados.actions.includes('OK') && (
                    <Button
                        color="primary"
                        endIcon={<ThumbUpAlt />}
                        onClick={this.fecharDialogoRemocao}
                        variant="contained"
                    >
                        Ok
                    </Button>
                )}
            </DialogActions>
        );
    }

    renderRedefinirParaComposicaoPadrao() {
        return renderBotaoRedefinirComposicao(
            this.novaComposicao,
            this.composicaoPadraoSessao,
            this.handleClickRedefinirParaComposicaoPadrao
        );
    }

    normalizarPresidentes(composicao) {
        const quantidadePresidentes = composicao.filter((comp) => comp.magistrado.presidenteSessao).length;

        if (quantidadePresidentes > 1) {
            for (const comp of composicao) {
                comp.magistrado.presidenteSessao = false;
            }
        }

        return composicao;
    }

    isRelatorDoProcesso(magistrado, relator) {
        if (!magistrado || !relator) return false;

        // ID e CPF são decisivos: se os dois lados têm o dado, é ele que define
        if (magistrado.id && relator.id) return magistrado.id === relator.id;
        if (magistrado.cpf && relator.cpf) return magistrado.cpf === relator.cpf;

        // Último recurso, só quando não há ID nem CPF dos dois lados
        return !!magistrado.sigla && !!relator.sigla && magistrado.sigla === relator.sigla;
    }

    chave(composicao) {
        return (composicao || [])
            .filter((comp) => comp.magistrado.presidenteSessao)
            .map((comp) => comp.magistrado.sigla)
            .toSorted((a, b) => a.localeCompare(b))
            .join('|');
    }

    mesmoPresidenteEmTodos() {
        const primeira = this.chave(this.processosSelecionados[0].composicao);

        return this.processosSelecionados.every((processo) => this.chave(processo.composicao) === primeira);
    }

    async recuperarProcuradoresSessoes() {
        for (const sessaoId in this.processosSelecionadosPorSessao) {
            const procurador = await this.sessaoService.recuperarProcurador(sessaoId);
            runInAction(() => (this.procuradoresSelecionados[sessaoId] = procurador));
        }
    }

    prepararAtualizarCertidao() {
        const processosAtualizaveis = [];

        for (const registro of this.processosSelecionados) {
            if (registro.certidaoGerada && !registro.certidaoJulgamentoAssinada) {
                processosAtualizaveis.push(registro.processo.numeroCompleto);
            }
        }
        this.exibirAtualizarCertidao = processosAtualizaveis.length > 0;
        this.tooltipAtualizarCertidao =
            'Atualizar composição/procurador do(s) processo(s): ' + processosAtualizaveis.join(', ');
    }

    get composicaoPadraoSessao() {
        return getComposicaoPadraoSessao(this.sessaoStore, this.opcoesMagistrados);
    }

    get processos() {
        return (this.store.processosFiltrados || []).filter((registro) => this.filtrarProcessoPeloNumero(registro));
    }

    get processosPauta() {
        return (this.pautaJulgamentoStore.processosPautaSelecionadaFiltrados || []).filter((registro) =>
            this.filtrarProcessoPeloNumero(registro)
        );
    }

    get processosPorPagina() {
        return this.observableProps.pagina === ROTA.PAUTA.id ? this.processosPauta : this.processos;
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get processosSelecionadosPauta() {
        return this.processosSelecionaveisPauta.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get processosSelecionaveisPauta() {
        return this.processosPauta.filter((registro) => !registro.certidaoJulgamentoAssinada);
    }

    get processosSelecionaveis() {
        return this.processos.filter((registro) => !registro.certidaoJulgamentoAssinada);
    }

    get processosSelecionaveisPorPagina() {
        return this.observableProps.pagina === ROTA.PAUTA.id
            ? this.processosSelecionaveisPauta
            : this.processosSelecionaveis;
    }

    get observacaoDeps() {
        return {
            salaSessaoStore: this.salaSessaoStore,
            certidaoService: this.certidaoService,
            sessaoStore: this.sessaoStore
        };
    }

    async gravarProcurador(registro) {
        let resultado;

        try {
            if (registro.necessitaImportacaoSalaSessao === true) {
                throw new Error('Processo não importado.');
            }

            resultado = await this.processoService.gravarProcuradorLote(
                registro,
                this.procuradoresSelecionados[registro.sessaoId]
            );

            if (resultado && !ErrorUtil.isResultadoErro(resultado)) {
                runInAction(() => (registro.procurador = this.procuradoresSelecionados[registro.sessaoId]));

                try {
                    await this.atualizarCertidao(registro);
                } catch (error) {
                    throw new Error(
                        'Procurador gravado com sucesso, porém ocorreu uma falha ao atualizar a informação na certidão.',
                        { cause: error }
                    );
                }
            }
        } catch (error) {
            resultado = ErrorUtil.getResultadoProcessamentoErro(error, registro.processo.numeroCompleto);
        }

        this.salaSessaoStore.incrementarProgressoLote();

        return resultado;
    }

    async atualizarCertidao(registro) {
        if (this.atualizarCertidaoProcurador && registro.certidaoGerada && !registro.certidaoJulgamentoAssinada) {
            await this.certidaoService.atualizarResumoCertidao(
                this.sessaoStore.sessaoSelecionada,
                registro,
                this.procuradoresSelecionados[registro.sessaoId]
            );
        }
    }

    renderModalAlterarComposicaoMagistrados() {
        return (
            <ModalConfirmacao
                callbackCancelar={this.callbackCancelar}
                callbackConfirmar={this.callbackConfirmarMagistrado}
                open={this.modalConfirmacaoMagistradoOpen}
                titulo={'Alterar composição dos magistrados'}
            >
                <Typography>
                    Atenção! As composições dos processos selecionados serão substituídas pela nova composição. Deseja
                    continuar?
                </Typography>
            </ModalConfirmacao>
        );
    }

    async alterarComposicoesEmLote(magistrados) {
        if (this.isPautaJulgamento) {
            await this.pautaJulgamentoStore.processarLote({
                indeterminate: true,
                titulo: 'Alterando composições',
                qtdTotalProcessos: this.processosSelecionadosPauta.length,
                lotesProcessos: this.processosSelecionadosPauta,
                funcaoOperacao: (registro) => this.gravarComposicao(registro, magistrados)
            });
        } else {
            await this.store.processarLote({
                titulo: 'Alterando composições',
                qtdTotalProcessos: this.processosSelecionados.length,
                lotesProcessos: this.processosSelecionados,
                funcaoOperacao: (registro) => this.gravarComposicao(registro, magistrados)
            });
        }
        this.handleCloseDialogComposicao();
    }

    async validarMagistrados(magistrados) {
        let isMagistradosValidos = true;

        if (this.sessoesProcessos) {
            for (const sessao of this.sessoesProcessos) {
                const magistradosInvalidos = await this.validarLocalizacaoMagistrados(sessao?.id, magistrados);

                if (magistradosInvalidos && magistradosInvalidos.length > 0) {
                    const mensagens = [];
                    isMagistradosValidos = false;
                    const magistradosInvalidosSemLocalizacao = magistradosInvalidos.filter(
                        (m) => m.situacao.elemento === 'SEM_LOCALIZACAO'
                    );

                    if (magistradosInvalidosSemLocalizacao.length > 0) {
                        mensagens.push(
                            'Não é permitido inserir na composição Magistrado sem localização no OJC: ' +
                                magistradosInvalidosSemLocalizacao.map((magistrado) => magistrado.sigla).join(', ')
                        );
                    }

                    const magistradosInvalidosForaDoPrazo = magistradosInvalidos.filter(
                        (m) => m.situacao.elemento === 'FORA_DO_PRAZO'
                    );

                    if (magistradosInvalidosForaDoPrazo.length > 0) {
                        mensagens.push(
                            'Não é permitido inserir na composição Magistrado fora das datas de atuação no OJC: ' +
                                magistradosInvalidosForaDoPrazo.map((magistrado) => magistrado.sigla).join(', ')
                        );
                    }

                    this.mensagemStore.abrirMensagemErro(
                        <div>
                            {mensagens.map((mensagem) => (
                                <div key={this.nextKey}>{mensagem}</div>
                            ))}
                        </div>
                    );
                }
            }
        }

        return isMagistradosValidos;
    }

    async gravarComposicao(registro, magistrados) {
        let resultado = await this.processoService.gravarComposicaoLote(registro, magistrados, true);

        if (resultado && !ErrorUtil.isResultadoErro(resultado)) {
            const composicaoAnterior = toJS(registro.composicao) || [];

            runInAction(() => (registro.composicao = toJS(this.novaComposicao)));

            try {
                this.atualizarRelatorProcesso(registro);
                await this.atualizarResumoCertidao(registro, magistrados);
                await ObservacaoCertidaoUtil.atualizarTextosCertidao(
                    registro,
                    ObservacaoCertidaoUtil.transformarAusencia(magistrados, composicaoAnterior, this.observacaoDeps),
                    this.observacaoDeps,
                    ObservacaoCertidaoUtil.opcoesAlteracaoComposicao(registro, this.atualizarCertidaoComposicao)
                );
            } catch (error) {
                resultado = ErrorUtil.getResultadoProcessamentoErro(error, registro.processo.numeroCompleto);
            }
        }

        if (this.isPautaJulgamento) {
            this.pautaJulgamentoStore.incrementarProgressoLote();
        } else {
            this.salaSessaoStore.incrementarProgressoLote();
        }

        return resultado;
    }

    async atualizarResumoCertidao(registro, magistrados) {
        if (this.atualizarCertidaoComposicao && registro.certidaoGerada && !registro.certidaoJulgamentoAssinada) {
            await this.certidaoService.atualizarResumoCertidao(
                this.sessaoStore.sessaoSelecionada,
                registro,
                registro.procurador,
                magistrados
            );
        }
    }

    async validarLocalizacaoMagistrados(sessaoId, magistrados) {
        const retorno = [];

        if (this.sessaoStore.isSessaoPJe(sessaoId)) {
            const promises = magistrados.map(async (magistrado) => {
                const situacao = await this.sessaoStore.verificarLocalizacaoMagistrado(sessaoId, magistrado);

                if (situacao.tipo === 'ERRO') {
                    retorno.push({ ...magistrado, situacao: situacao });
                }
            });
            await Promise.all(promises);
        }

        return retorno;
    }

    get processosSelecionadosPorSessao() {
        return this.salaSessaoStore.separarProcessosPorSessao(this.processosSelecionados);
    }

    get sessoesProcessos() {
        const processosPorSessao = this.processosSelecionadosPorSessao;

        if (processosPorSessao) {
            const retorno = [];

            for (const sessaoId in processosPorSessao) {
                retorno.push(this.sessaoStore.sessoesSessaoSelecionada.find((sessao) => sessao.id === sessaoId));
            }

            return retorno;
        }

        return '';
    }

    atualizarRelatorProcesso(registro) {
        if (!(registro.processo.relator && registro.processo.relator.sigla)) {
            return;
        }

        const relator = registro.composicao.find((comp) =>
            this.isRelatorDoProcesso(comp.magistrado, registro.processo.relator)
        );

        if (relator) {
            registro.processo.relator.ausente = relator.magistrado.ausente;
            registro.processo.relator.presidenteSessao = relator.magistrado.presidenteSessao;
        }
    }

    get opcoesMagistradosAdicionar() {
        return filtrarOpcoesDisponiveis(
            this.opcoesMagistrados,
            this.novaComposicao,
            ComposicaoUtil.localizacaoUsuario(this.usuarioStore),
            { considerarSubstitutos: false }
        );
    }

    get opcoesMagistrados() {
        return getOpcoesMagistrados(this.dominioStore, this.impedimentos);
    }

    get impedimentos() {
        const impedimentos = [];

        for (const registro of this.processosSelecionados) {
            if (registro.impedimentos) {
                for (const impedimento of registro.impedimentos) {
                    impedimentos.push({ ...impedimento, numeroProcesso: registro.processo.numeroCompleto });
                }
            }
        }

        return impedimentos;
    }

    validarLocalizacaoMagistrado(magistrado = this.magistradoParaAdicionar) {
        if (
            this.processosSelecionados.filter((registro) => registro.processo.origem === Configuracao.ORIGEM_SIJ)
                .length === 0
        ) {
            if (!this.processosSelecionados[0].sessaoId) {
                console.error(
                    'Id da sessão não está disponível na alteração de composição',
                    JSON.stringify(this.processosSelecionados[0])
                );
            }

            return this.sessaoStore.verificarLocalizacaoMagistrado(this.processosSelecionados[0].sessaoId, magistrado);
        }
        return Promise.resolve({ tipo: 'SUCESSO' });
    }

    get mensagemLoteSemProcessos() {
        return 'Não há processos na sessão' + this.complementoMensagemFiltrando;
    }

    atualizarRegistroVirtual() {
        const todosSij = this.processosSelecionados.every((r) => r.processo.origem === Configuracao.ORIGEM_SIJ);
        const numerosProcessosPje = this.processosSelecionados
            .filter((r) => r.processo.origem === Configuracao.ORIGEM_PJE)
            .map((r) => r.processo.numeroCompleto);

        this.registroVirtualComposicao = {
            sessaoId: this.processosSelecionados[0]?.sessaoId,
            composicao: this.novaComposicao,
            impedimentos: [],
            certidaoGerada: this.exibirAtualizarCertidao,
            certidaoJulgamentoAssinada: false,
            necessitaImportacaoSalaSessao: false,
            numerosProcessosPje,
            processo: { origem: todosSij ? Configuracao.ORIGEM_SIJ : Configuracao.ORIGEM_PJE }
        };
    }

    getProcessosRelator(magistrado) {
        return this.processosSelecionados.filter((registro) =>
            this.isRelatorDoProcesso(magistrado, registro.processo?.relator)
        );
    }

    getProcessosRedator(magistrado) {
        return this.processosSelecionados.filter((registro) =>
            this.isRelatorDoProcesso(magistrado, registro.processo?.redator)
        );
    }

    isRelatorOuRedatorDoProcesso(magistrado, registro) {
        return (
            this.isRelatorDoProcesso(magistrado, registro.processo?.relator) ||
            this.isRelatorDoProcesso(magistrado, registro.processo?.redator)
        );
    }

    getProcessosRelatorOuRedator(magistrado) {
        return this.processosSelecionados.filter((registro) => this.isRelatorOuRedatorDoProcesso(magistrado, registro));
    }

    getTituloRedator(magistrado, processosRedator) {
        if (!processosRedator || processosRedator.length === 0) return null;

        const flexaoCargo = magistrado.genero === 'M' ? '' : 'a';
        const complemento = processosRedator.length > 1 ? 'nos processos' : 'no processo';

        return [
            `Redator${flexaoCargo} ${complemento}:`,
            ...processosRedator.map((registro) => registro.processo.numeroCompleto)
        ].join('\n');
    }

    getResumoRelatorRedator(magistrado, processosRelator, processosRedator) {
        const total = processosRelator.length + processosRedator.length;

        if (total <= 5) {
            return null;
        }

        const flexaoCargo = magistrado.genero === 'M' ? '' : 'a';
        const cargos = [];

        if (processosRelator.length > 0) cargos.push(`Relator${flexaoCargo}`);
        if (processosRedator.length > 0) cargos.push(`Redator${flexaoCargo}`);

        return `${magistrado.nome} é ${cargos.join(' e ')} em vários processos selecionados`;
    }

    getRolesMagistrado(magistrado, entradaAtual) {
        return ComposicaoUtil.getRolesMagistrado(
            magistrado,
            this.registroVirtualComposicao.processo,
            this.dominioStore,
            entradaAtual
        );
    }

    render() {
        return (
            <div>
                <Box
                    className="corBotao"
                    sx={{ mr: 1, cursor: 'pointer' }}
                >
                    <Tooltip
                        placement="top-start"
                        title={<Typography>Alterar composição em lote</Typography>}
                    >
                        <Box onClick={this.handleClickIcone}>
                            <IconeMagistrado sx={{ color: 'black' }} />
                        </Box>
                    </Tooltip>
                </Box>
                <Dialog
                    fullWidth
                    slotProps={{
                        paper: {
                            sx: {
                                height: '100%'
                            }
                        }
                    }}
                    maxWidth="xl"
                    onClose={this.handleCloseDialog}
                    open={this.dialogOpen}
                >
                    {this.renderTituloComposicaoLote}
                    {this.renderConteudoComposicaoLote}
                    {this.renderModalAlertaComposicao()}

                    <DialogActions>
                        <Button
                            color="secondary"
                            endIcon={<CancelIcon />}
                            onClick={this.handleCloseDialog}
                            variant="outlined"
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    maxWidth="lg"
                    onClose={this.handleCloseDialogProcurador}
                    open={this.dialogProcuradorOpen}
                >
                    <DialogTitle sx={{ paddingBottom: '6px' }}>
                        Informe o novo Procurador para os processos selecionados
                    </DialogTitle>
                    {this.renderConteudoDialogProcurador}
                    <DialogActions>
                        <Button
                            color="secondary"
                            endIcon={<CancelIcon />}
                            onClick={this.handleCloseDialogProcurador}
                            variant="outlined"
                        >
                            Cancelar
                        </Button>
                        <Button
                            color="primary"
                            endIcon={<SaveIcon />}
                            onClick={this.handleClickAlterarProcuradores}
                            variant="outlined"
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    slotProps={{
                        paper: {
                            sx: {
                                height: '80vh'
                            }
                        }
                    }}
                    maxWidth="xl"
                    onClose={this.fecharDialogComposicao}
                    open={this.dialogComposicaoOpen}
                >
                    <DialogTitle sx={{ paddingBottom: '5px' }}>
                        Informe a nova composição dos processos selecionados
                    </DialogTitle>
                    {this.renderConteudoDialogComposicao}
                    <DialogActions>
                        <div
                            style={{
                                display: 'flex',
                                marginTop: '10px',
                                marginBottom: '4px',
                                marginLeft: '8px',
                                alignContent: 'center',
                                flexGrow: 1,
                                alignItems: 'center',
                                justifyContent: 'left'
                            }}
                        >
                            <AutoComplete
                                apresentarTextoSecundario
                                dense
                                outlined
                                label="Selecione..."
                                onChange={this.callbackAutoCompleteAddMagistrado}
                                options={this.opcoesMagistradosAdicionar}
                                value={this.magistradoParaAdicionar ? this.magistradoParaAdicionar.sigla : null}
                            />

                            <Tooltip title={<Typography>Adicionar magistrado</Typography>}>
                                <IconButton
                                    color={'primary'}
                                    disabled={!this.magistradoParaAdicionar}
                                    onClick={this.adicionarMagistrado}
                                    size="large"
                                >
                                    <PersonAdd />
                                </IconButton>
                            </Tooltip>
                        </div>
                        {this.renderRedefinirParaComposicaoPadrao()}
                        <Button
                            color="secondary"
                            endIcon={<CancelIcon />}
                            onClick={this.fecharDialogComposicao}
                            variant="outlined"
                        >
                            Cancelar
                        </Button>
                        <Tooltip
                            title={ComposicaoUtil.tooltipBotaoSalvar(
                                this.existePresidenteNaComposicao,
                                this.composicaoFoiAlterada,
                                this.atualizarCertidaoComposicao
                            )}
                        >
                            <span>
                                <Button
                                    color="primary"
                                    disabled={this.deveDesabilitarBotaoSalvar}
                                    endIcon={<SaveIcon />}
                                    onClick={this.handleClickAlterarComposicoes}
                                    variant="contained"
                                >
                                    Salvar
                                </Button>
                            </span>
                        </Tooltip>
                        {this.renderModalAlterarComposicaoMagistrados()}
                    </DialogActions>
                </Dialog>
                {this.modalConfirmacaoFecharComposicaoOpen ? (
                    <ModalConfirmacao
                        callbackCancelar={this.callbackCancelarFecharComposicao}
                        callbackConfirmar={this.callbackConfirmarFecharComposicao}
                        open={this.modalConfirmacaoFecharComposicaoOpen}
                        titulo={'Descartar alterações feitas?'}
                    >
                        <Typography>Há alterações NÃO salvas. Clicando SIM as alterações serão DESCARTADAS.</Typography>
                    </ModalConfirmacao>
                ) : null}
            </div>
        );
    }

    get deveDesabilitarBotaoSalvar() {
        const temComposicaoValida = Boolean(this.novaComposicao && this.novaComposicao.length > 0);
        const possuiEstruturaValida = temComposicaoValida && this.existePresidenteNaComposicao;

        if (!possuiEstruturaValida) {
            return true;
        }

        const permiteSalvar = this.composicaoFoiAlterada || Boolean(this.atualizarCertidaoComposicao);

        return !permiteSalvar;
    }

    get renderConteudoComposicaoLote() {
        return (
            <>
                <OperacoesEmLoteSelecionar
                    processos={this.processosPorPagina}
                    processosSelecionaveis={this.processosSelecionaveisPorPagina}
                />
                <PainelProcessosOperacoesEmLote
                    alertasProcessos={this.alertasProcessos}
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                    processos={this.processosPorPagina}
                />
            </>
        );
    }

    get renderTituloComposicaoLote() {
        return (
            <DialogTitle
                id="simple-dialog-title"
                sx={{ p: '16px 24px 0px' }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h4 style={{ margin: '0px' }}>Alterar composição em lote</h4>
                    </div>
                    <div style={{ margin: '0px 10px' }}>
                        <NumeroProcesso
                            dense
                            callbackOnChange={this.callbackNumeroProcesso}
                            clickLimpar={this.limparProcessoPesquisa}
                            tooltip="Número do processo a ser pesquisado na listagem"
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip
                            placement="top-start"
                            title={<Typography>Definir nova composição para os processos selecionados</Typography>}
                        >
                            <IconButton
                                onClick={this.handleClickIconeComposicao}
                                size="large"
                                sx={{ p: 1 }}
                            >
                                <IconeMagistrado sx={{ color: 'black' }} />
                            </IconButton>
                        </Tooltip>
                        {this.isComponenteHabilitado('ProcuradorLote') && (
                            <Tooltip
                                placement="top-start"
                                title={<Typography>Alterar procurador dos processos selecionados</Typography>}
                            >
                                <IconButton
                                    onClick={this.handleClickIconeProcurador}
                                    size="large"
                                    sx={{ padding: '8px', color: 'black' }}
                                >
                                    <IconeProcurador />
                                </IconButton>
                            </Tooltip>
                        )}
                        <div style={{ display: 'flex', alignItems: 'center', margin: '10px', paddingTop: '5px' }}>
                            <PainelFiltros />
                        </div>
                        <FiltroRapido id="filtroRapidoComposicaoEmLote" />
                    </div>
                </div>
            </DialogTitle>
        );
    }

    get renderConteudoDialogProcurador() {
        return (
            <DialogContent sx={{ paddingBottom: '6px' }}>
                {this.renderOpcaoAtualizarCertidao(
                    this.atualizarCertidaoProcurador,
                    this.handleChangeAtualizarCertidaoProcurador
                )}
                <ProcuradorSessao
                    callbackAutoComplete={this.callbackAutoCompleteProcurador}
                    processosPorSessao={this.processosSelecionadosPorSessao}
                    procuradoresSelecionados={this.procuradoresSelecionados}
                    sessoes={this.sessoesProcessos}
                />
            </DialogContent>
        );
    }

    get renderCarregando() {
        if (!this.desmarcandoProcessos) {
            return null;
        }

        return (
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    zIndex: 9999
                }}
            >
                <CircularProgress size={48} />
            </Box>
        );
    }

    get renderConteudoDialogComposicao() {
        return (
            <DialogContent sx={{ height: '100%', position: 'relative' }}>
                {this.renderCarregando}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        {this.renderOpcaoAtualizarCertidao(
                            this.atualizarCertidaoComposicao,
                            this.handleChangeAtualizarCertidaoComposicao
                        )}
                    </div>
                </div>
                <Table sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 32px)' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                align="center"
                                sx={{ width: '105px' }}
                            >
                                Magistrado
                            </TableCell>
                            <TableCell
                                align="center"
                                sx={{ width: '80px' }}
                            >
                                Presidente
                            </TableCell>
                            <TableCell
                                align="center"
                                sx={{ width: '80px' }}
                            >
                                Ausente
                            </TableCell>
                            <TableCell
                                align="center"
                                sx={{ width: '80px' }}
                            >
                                Impedimentos
                            </TableCell>
                            <TableCell
                                align="center"
                                sx={{ width: '105px' }}
                            >
                                Substituto
                            </TableCell>
                            <TableCell
                                align="center"
                                sx={{ width: '78px' }}
                            />
                        </TableRow>
                    </TableHead>
                    <TableBody
                        id="tBodyComposicaoProcessoLote"
                        sx={{ flex: 1, overflowY: 'auto' }}
                    >
                        {this.novaComposicao.length > 0 &&
                            this.novaComposicao.map((composicao, index) => {
                                const magistrado = composicao.magistrado;

                                if (!magistrado.sigla) {
                                    return null;
                                }
                                const entradaAtual = ComposicaoUtil.getEntradaDominioAtual(
                                    magistrado,
                                    this.dominioStore
                                );
                                const roles = this.getRolesMagistrado(magistrado, entradaAtual);
                                const processosRelator = this.getProcessosRelator(magistrado);
                                const processosRedator = this.getProcessosRedator(magistrado);
                                const estiloChip = ComposicaoUtil.estiloChipMagistrado({
                                    ...roles,
                                    redator: processosRedator.length > 0
                                });
                                const resumoRelatorRedator = this.getResumoRelatorRedator(
                                    magistrado,
                                    processosRelator,
                                    processosRedator
                                );
                                const titleBase = resumoRelatorRedator
                                    ? null
                                    : ComposicaoUtil.defineTitle(
                                          roles,
                                          magistrado.nome,
                                          magistrado,
                                          ComposicaoUtil.defineRedatorRelator,
                                          (mag) => this.getProcessosRelator(mag)
                                      );
                                const titleRedator = resumoRelatorRedator
                                    ? null
                                    : this.getTituloRedator(magistrado, processosRedator);
                                const title =
                                    resumoRelatorRedator ||
                                    (titleBase || titleRedator ? (
                                        <div style={{ whiteSpace: 'pre-line' }}>
                                            {titleBase}
                                            {titleBase && titleRedator ? '\n' : ''}
                                            {titleRedator}
                                        </div>
                                    ) : (
                                        ''
                                    ));

                                return (
                                    <TableRow key={this.nextKey}>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '105px' }}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <Tooltip
                                                    sx={{ whiteSpace: 'pre-line' }}
                                                    title={title || ''}
                                                >
                                                    <Chip
                                                        label={composicao.magistrado.sigla}
                                                        sx={estiloChip}
                                                    />
                                                </Tooltip>
                                                {renderChipOrigemSigla(entradaAtual)}
                                                <BotaoAlternarSigla
                                                    dominioStore={this.dominioStore}
                                                    magistrado={composicao.magistrado}
                                                    novaComposicao={this.novaComposicao}
                                                    registroVirtualComposicao={this.registroVirtualComposicao}
                                                    salaSessaoStore={this.salaSessaoStore}
                                                />
                                                {this.renderSubstituicao(magistrado)}
                                            </div>
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '80px' }}
                                        >
                                            <Radio
                                                checked={
                                                    !this.existeMaisDeUmPresidenteNaComposicao &&
                                                    composicao.magistrado.presidenteSessao === true
                                                }
                                                disabled={ComposicaoUtil.isMagistradoSubstitutoDefinido(magistrado)}
                                                onChange={() => this.toggleMagistradoPresidente(composicao.magistrado)}
                                            />
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '80px' }}
                                        >
                                            <Tooltip title="Marcar ausência de magistrado">
                                                <span>
                                                    <Checkbox
                                                        disabled={
                                                            ComposicaoUtil.isMagistradoSubstitutoDefinido(magistrado) ||
                                                            ComposicaoUtil.isMagistradoSubstituidoDefinido(magistrado)
                                                        }
                                                        onChange={() =>
                                                            this.toggleMagistradoAusente(composicao.magistrado)
                                                        }
                                                        checked={composicao.magistrado.ausente}
                                                    />
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '80px' }}
                                        >
                                            {getIconesImpedimentoMagistrado(composicao.magistrado, this.impedimentos)}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '105px' }}
                                        >
                                            {this.renderAdicionarRemoverMagistradoSubstituto(magistrado, index)}
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip
                                                placement="left"
                                                title="Remover"
                                            >
                                                <IconButton
                                                    onClick={() =>
                                                        this.handleClickRemoverMagistrado(composicao.magistrado)
                                                    }
                                                    disabled={ComposicaoUtil.isMagistradoSubstitutoDefinido(magistrado)}
                                                    size="large"
                                                    sx={{ cursor: 'pointer', padding: '4px' }}
                                                >
                                                    <Clear />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
                {this.renderDialogRemocao}
            </DialogContent>
        );
    }

    renderOpcaoAtualizarCertidao(checked, handleChange) {
        return (
            this.exibirAtualizarCertidao && (
                <Tooltip
                    placement="left"
                    title={this.tooltipAtualizarCertidao}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox
                            checked={checked}
                            onChange={handleChange}
                            sx={{ padding: '4px' }}
                        />
                        <Typography sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
                            Atualizar composição/procurador nas certidões já geradas e não assinadas
                        </Typography>
                    </div>
                </Tooltip>
            )
        );
    }

    get renderDialogRemocao() {
        if (!this.dialogRemocaoAberto) {
            return null;
        }
        const dados = this.dadosDialogRemocao;

        if (!dados) return null;

        return (
            <Dialog
                maxWidth="sm"
                onClose={this.fecharDialogoRemocao}
                open={this.dialogRemocaoAberto}
            >
                <DialogTitle>Remoção de magistrado da composição</DialogTitle>
                <DialogContent>{this.renderTextoDialogRemocao()}</DialogContent>
                {this.renderBotoesDialogRemocao(dados)}
            </Dialog>
        );
    }

    get existePresidenteNaComposicao() {
        if (this.existeMaisDeUmPresidenteNaComposicao) return false;

        return ComposicaoUtil.existePresidente(this.novaComposicao);
    }

    get existeMaisDeUmPresidenteNaComposicao() {
        return this.novaComposicao?.filter((composicao) => composicao.magistrado.presidenteSessao).length > 1;
    }
}

export default inject('stores')(observer(ComposicaoEmLote));
